
/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.refreshRefs();
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    refreshRefs() {
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement
        ? this.parentElement.querySelectorAll('.side-panel-content--tab-panel')
        : [];
    }
    setupButtonObservers() {
      if (this._cbSearchTabsBound) {
        return;
      }
      this._cbSearchTabsBound = true;
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', () => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.refreshRefs();
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      if (this.buttons[i]) {
        this.buttons[i].classList.add('tab-active');
      }

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      if (this.panels[i]) {
        this.panels[i].classList.add('tab-active');
      }
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}
